import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'
import CrossIcon from '../../../../Assets/Images/icons/cross'

const AddConversationView = ({ onClick, classes }) => {
  return (
    <div className={classes.wrapper} onClick={onClick}>
      <span className={classes.text}>Create conversation</span>
      <i className={classes.icon}>
        <CrossIcon />
      </i>
    </div>
  )
}

AddConversationView.propTypes = {
  classes: PropTypes.object,
  onClick: PropTypes.func,
}

export default injectStyles(styles)(AddConversationView)



// WEBPACK FOOTER //
// ./src/Components/Chat/AddConversation/component/AddConversationView.js